import React from 'react';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

import '../App.css';

const Slideshow = props => {
    return (
        <div className="slide-container">
            <Slide infinite={false} indicators={true} arrows={true} autoplay={false} transitionDuration={300}>
                <div className="each-slide">
                    <div>
                        <img className="the-img" src={props.img_1} alt=""></img>
                    </div>
                </div>
                <div className="each-slide">
                    <div>
                        <img className="the-img" src={props.img_2} alt=""></img>
                    </div>
                </div>
                <div className="each-slide">
                    <div>
                        <img className="the-img" src={props.img_3} alt=""></img>
                    </div>
                </div>
            </Slide>
        </div>
    )
}

export default Slideshow;